/**
 * Build a Google Maps directions URL only when a location has usable
 * coordinates. Delivery-only records commonly omit latitude/longitude, so
 * callers must treat a null return value as "directions unavailable."
 */
export function getStoreDirectionsUrl(location) {
  const latitude = Number.parseFloat(location?.fields?.Lat);
  const longitude = Number.parseFloat(location?.fields?.Lng);

  const validLatitude =
    Number.isFinite(latitude) && latitude >= -90 && latitude <= 90;
  const validLongitude =
    Number.isFinite(longitude) && longitude >= -180 && longitude <= 180;

  if (!validLatitude || !validLongitude) return null;

  return `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`;
}
